import React, {memo} from 'react';
import {Platform, View} from 'react-native';

import { StyleSheet } from 'react-native';

import {SVGIcon, RNEButton, RNEText} from '../../components';
import { width, height, totalSize } from 'react-native-dimension';

interface SwitchPatientConfirmationModalProps {
  onCancel?: () => void;
  onConfirm?: () => void;
}

function SwitchPatientConfirmationModal(
  props: SwitchPatientConfirmationModalProps,
) {

  return (
    <View style={rneStyles.root}>
      <RNEText
        label="Are you sure you want to switch the patient profile?"
        variant="header"
        align="center"
        weight="600"
        color="accent"
        style={{fontSize: totalSize(2), fontFamily:'Quicksand-Bold'}}
        
      />

      <View style={rneStyles.actionContainer}>
        <View style={rneStyles.buttonContainer}>
          <RNEButton
            title="Cancel"
            color="accent"
            onPress={props.onCancel}
            style={rneStyles.buttonStyle}
            variant="outlined"
          />
        </View>
        <RNEButton
          title="Switch"
          color="accent"
          onPress={props.onConfirm}
          style={rneStyles.buttonStyle}
        />
      </View>
    </View>
  );
}

const rneStyles = StyleSheet.create(({
  root: {
    maxWidth: width(90),
    padding: totalSize(2),
    height: height(25),
    justifyContent: 'center',
  },
  actionContainer: {
    marginTop: height(5),
    justifyContent: 'center',
    flexDirection: 'row',
  },
  buttonContainer: {
    marginRight: 16,
  },
  buttonStyle: {
    width: 120,
  },
}));

export default memo(SwitchPatientConfirmationModal);
